import { render, staticRenderFns } from "./SharedManuscriptList.vue?vue&type=template&id=366acbc5&scoped=true&"
import script from "./SharedManuscriptList.vue?vue&type=script&lang=ts&"
export * from "./SharedManuscriptList.vue?vue&type=script&lang=ts&"
import style0 from "./SharedManuscriptList.vue?vue&type=style&index=0&id=366acbc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366acbc5",
  null
  
)

export default component.exports